<div class="" fxLayout="column">
  <i class="fa fa-times" (click)="onClick()"></i>
  <div class="container" fxLayout="column">
    <h3>{{data.header}}</h3>
    <iframe width="100%" height="458" [src]="url" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</div>
